;(function () {
    function InnovationPartnerSearch() {
        var _this = this

        this.input = document.querySelectorAll('[data-innovation-partner-element="search-input"]')[0]

        this.innovationPartners = document.querySelectorAll('[data-innovation-partner-element="innovation-partner"]')

        this.filters = document.querySelectorAll('[data-innovation-partner-element="search-filter"]')

        this.noResultsMessage = document.querySelectorAll('[data-innovation-partner-element="no-result-message"]')[0]

        this.resetSearchButton = document.querySelectorAll('[data-innovation-partner-element="reset-button"]')[0]

        this.resultList = document.querySelectorAll('[data-innovation-partner-element="result-list"]')[0]

        /**
         * Holds the current search term
         * @type {string}
         */
        this.currentPostalCode = ''

        /**
         * Holds all active filters
         * @type {*[]}
         */
        this.activeFilters = []

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.initSearchInput()
            _this.initFilters()
            _this.initResetButton()
        }

        /**
         * Initialize listener for input field
         */
        this.initSearchInput = function () {
            this.input.addEventListener('input', function (event) {
                _this.currentPostalCode = event.target.value
                _this.updateList()
            })
        }

        /**
         * Initialize listener for checkboxes
         */
        this.initFilters = function () {
            _this.filters.forEach(function (filter) {
                filter.addEventListener('click', function (event) {
                    _this.toggleFilter(event.target.dataset['innovationPartnerFilter'])
                    _this.updateList()
                })
            })
        }

        /**
         * Initialize listener for checkboxes
         */
        this.initResetButton = function () {
            _this.resetSearchButton.addEventListener('click', function (event) {
                _this.resetFilters()
                _this.resetSearchTerm()
                _this.updateList()
            })
        }

        /**
         * Toggles the filter element in the global array if the checkbox is clicked
         * @param filter
         */
        this.toggleFilter = function (filter) {
            var index = _this.activeFilters.indexOf(filter)
            if (index === -1) {
                _this.activeFilters.push(filter)
            } else {
                _this.activeFilters.splice(index, 1)
            }
        }

        /**
         * Update the displayed partners
         * Show all partners if a search would return no result
         */
        this.updateList = function () {
            filteredPartners = _this.filterPartners()
            if (filteredPartners < 1) {
                _this.showElement(this.noResultsMessage)
                _this.hideElement(this.resultList)
            } else {
                _this.hideElement(this.noResultsMessage)
                _this.showElement(this.resultList)
            }
        }

        /**
         * Filter elements by search term (postal code) and activated fitlers
         * Returns the amount of elements matching the filters
         * @returns {number}
         */
        this.filterPartners = function () {
            var count = 0
            _this.innovationPartners.forEach(function (partner) {
                // filter for postal code
                if (partner.dataset['innovationPostalCode'].includes(_this.currentPostalCode)) {
                    // filter by activated filters if there are any
                    if (_this.activeFilters.length < 1 || _this.isPartnerVisibleByFilters(partner)) {
                        _this.showElement(partner)
                        count++
                    } else {
                        _this.hideElement(partner)
                    }
                } else {
                    _this.hideElement(partner)
                }
            })
            return count
        }

        /**
         * Returns if the given partner should be displayed for the currently selected filters
         * @param partner
         * @returns {boolean}
         */
        this.isPartnerVisibleByFilters = function (partner) {
            var partnerFilterAttribute = partner.dataset['innovationFilter']
            if (partnerFilterAttribute !== undefined) {
                var partnerFilters = partnerFilterAttribute.split(',')
                var foundFilter = false
                partnerFilters.forEach(function (filter) {
                    if (_this.activeFilters.includes(filter)) {
                        foundFilter = true
                    }
                })
            } else {
                // Hide partners without applied filters if any filter is active
                return this.activeFilters.length < 1
            }
            return foundFilter
        }

        /**
         * Resets the filters
         */
        this.resetFilters = function () {
            _this.activeFilters = []
            _this.filters.forEach(function (filter) {
                filter.checked = false
            })
        }

        /**
         * Resets the postal code
         */
        this.resetSearchTerm = function () {
            _this.currentPostalCode = ''
            _this.input.value = ''
        }

        /**
         * Display all partners
         */
        this.showAll = function () {
            this.innovationPartners.forEach(function (partner) {
                _this.showElement(partner)
            })
        }

        /**
         * Hide given element
         * @param element
         */
        this.hideElement = function (element) {
            element.classList.add('hidden')
        }

        /**
         * Remove hidden class from element
         * @param element
         */
        this.showElement = function (element) {
            element.classList.remove('hidden')
        }

        _this.init()
    }

    window.Energy = window.Energy || {}

    window.Energy.InnovationPartnerSearch = InnovationPartnerSearch
})()

if (document.readyState != 'loading') {
    new window.Energy.InnovationPartnerSearch()
} else {
    document.addEventListener('DOMContentLoaded', new window.Energy.InnovationPartnerSearch())
}
